<template>




      <!--特惠推荐-->
        
        <div class="promotion_title"></div>
        <div class="carousel_content">
          <div class="promotion_carousel">

            <a-carousel  dotPosition="top">
              <template #customPaging="props">
               <span>{{getlabel(props.i)}}</span>
              </template>

              <div v-for="(item, index) in hotSaleHotels"  :id="index" :key="index">

                <a-row :gutter="16" class="promotion_hotel" >
                  <a-col :span="8" v-for="hotel in item.datas" :key="hotel.HotelId">                  
                    <a :href="`/hotel/detail?hotelId=`+hotel.HotelId"  class="promotion_hotel_piece" target="_blank" :title="hotel.HotelName">            
                      
                          <a-card hoverable>
                            <template #cover>
                              <a-image                  
                                :preview="false"
                                :alt="hotel.HotelName"
                                :src="hotel.PhotoUrl"
                                :height="260"
                                fallback="https://img.etxing.com/b2b/images/hotelDefault.svg"
                              />
                            </template>
                            <a-card-meta :title="hotel.HotelName">
                              <template #description>
                                
                                <div class="house_info">
                            
                                  <a-rate :value="hotel.Star" disabled style="font-size: 12px; color: #669933;" ></a-rate>                    
                                  <p><span class="hot_price">￥{{ hotel.LowestPrice }}</span><span class="hot_site">{{ hotel.HotelArea }}</span></p>
                                </div>


                              </template>
                            </a-card-meta>
                          </a-card>





                    </a>
                  </a-col>

                </a-row>

              </div>

            </a-carousel>

          </div>
        </div>
 






</template>
  
  <script>

  
  export default {
    name: 'hotelPromotion',
    data() {
      return {
        promotionCarousels:{
          active:0,
          datas:[]
        },

        hotSaleHotels:[
          {
            name:"all",
            label:"热门主推",
            datas:[]
          },
          {
            name:"hkmo",
            label:"港澳酒店",
            datas:[]
          },    
          {
            name:"inbound",
            label:"国内酒店",
            datas:[]
          }              
        ]
      };
    },
    created() {
      this.fetchHotSale();
    },
    methods: {
      getlabel(i){
        return this.hotSaleHotels[i].label;
      },
      async fetchHotSale() {       
        try {   
          const response = await this.$axios.get('/hotSale');
          this.promotionCarousels.datas = response.data.CityPromotions; // 根据 API 响应结构调整
          this.hotSaleHotels[0].datas=response.data.HotHotels.sort(() => Math.random() - 0.5).slice(0, 9)//随机获取全部主推酒店
          this.hotSaleHotels[1].datas=response.data.HotHotels.filter(h=>h.HotelArea=='香港'||h.HotelArea=='澳门').slice(0,9)//港澳酒店
          this.hotSaleHotels[2].datas=response.data.HotHotels.filter(h=>h.HotelArea!='香港'&&h.HotelArea!='澳门').slice(0,9)//国内酒店


        } catch (error) {
          console.error('获取数据失败:', error);
        }
      }
     
    }
  };
  </script>
  
<style scoped>
.hotel_promotion_section .promotion_title{height: 118px; font-size: 26px; text-align: center; color: #f60; 
background: url("@/assets/images/home_hotel_promotion_title.png") no-repeat center center; 
}


.carousel_content{width: 1202px; margin:0 auto; height: 100%; padding-top: 50px; background: none;}
.promotion_carousel{background: none;}

:deep(.slick-slide) {
padding-top: 10px;
padding: 10px;
}

:deep(.slick-dots)  {

 height: 70px;
  font-size: 16px;
  display: flex;
  justify-content: center;
  top:-135px; 
  left: 50%;

 
}
:deep(.slick-dots) li span{display: block;    border-bottom: 2px solid #fff;}
:deep(.slick-dots) li {
    line-height: 40px;
  height: 40px;
  text-indent: 0;
  cursor: pointer;
  width: 80px;
  margin: 10px 15px;
  cursor: pointer;

}
:deep(.slick-dots) li::after {
  border-left: 1px solid #807c7c;
}



:deep(.slick-dots) li.slick-active  {
  width: 80px;
  color: #669933;
 
  opacity: 1;
}

:deep(.slick-dots) li.slick-active span{ border-bottom: 2px solid #669933;}





  .promotion_hotel a.promotion_hotel_piece {

    height: 420px;
    cursor: pointer;
    display: block;
 
  }

  .promotion_hotel .promotion_hotel_piece .house_info {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    height: 70px;
    padding: 8px;
  }

  .promotion_hotel .promotion_hotel_piece .house_info i {
    font-size: 14px;
    color: #f90;
  }
  .promotion_hotel .promotion_hotel_piece .house_info p {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    color: #f90;
  }
  .promotion_hotel .promotion_hotel_piece .house_info p .hot_price {
    font-size: 20px;
  }
  .promotion_hotel .promotion_hotel_piece .house_info p .hot_site {
    color: #666;
  }




  </style>
  